import { createAction } from 'redux-act';

export const moduleName = 'submit';

export const setLoading = createAction<any>(`${moduleName}/loading`);
export const setIsReady = createAction<any>(`${moduleName}/isReady`);
